<template>
    <div class="warpper padding-sm">
        <div class="flex align-center justify-between">
            <div class="page-title line-height">发布组织动态</div>
            <div class="page-back" @click="$router.go(-1)">返回</div>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="form margin-top">
            <el-form-item label="标题" prop="title">
                <el-input v-model="ruleForm.title" placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-form-item label="缩略图" prop="images">
                <el-upload class="avatar-uploader"
                           :action="fileUpUrl"
                           :data="QiniuData"
                           :show-file-list="false"
                           :accept="'image/*'"
                           :on-error="uploadError"
                           :on-success="uploadSuccess"
                           :before-upload="beforeAvatarUpload" >
                    <el-image  v-if="ruleForm.images" :src="ruleForm.images" class="avatar" fit="cover" ></el-image>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div class="el-upload__tip" slot="tip">推荐尺寸大小154px*116px</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="通知文本" prop="content">
                <VueUditorWrap v-model="ruleForm.content" :config="myConfig"></VueUditorWrap>
            </el-form-item>
            <el-form-item>
                <el-button style="width: 220px" class="padding-lr-xl blue-btn" type="primary"
                           @click="submitForm('ruleForm')">{{id ? '更新' : '发布'}}
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import VueUditorWrap from 'vue-ueditor-wrap'
    import {fileUpUrl, filePath} from '@/config/index'
    import {bdEditConfig} from "@/utils/utils"
    import {addActive, editActive,getActiveDetail} from "@/api/organiz";
    import {genUpToken} from '@/utils/CryptoJS'
    export default {
        name: "dynamicEdit",
        data() {
            return {
                id: '',
                myConfig: bdEditConfig(),
                QiniuData: {
                    fname: '', //  文件名
                    key: '', //文件名字处理
                    token: genUpToken() //七牛云token
                },
                fileUpUrl: fileUpUrl,
                ruleForm: {
                    title: '',
                    images: '',
                    content: ''
                },
                rules: {
                    title: [
                        {required: true, message: '请输入标题', trigger: 'blur'},
                    ],
                    images: [
                        {required: true, message: '请上传缩略图', trigger: 'change'}
                    ],
                    content: [
                        {required: true, message: '请输入内容', trigger: 'blur'},
                    ],
                },
            }
        },
        created() {
            this.$emit('setIndex', [5, 1], '组织动态 - 发布')
            this.id = Number(this.$route.params.id)
            if (this.id) this.init()
        },
        components: {VueUditorWrap,},
        methods: {
            async init() {
                let _data = await getActiveDetail(this.id)
                if (_data.status === 200) {
                    this.ruleForm = {
                        title: _data.data.title,
                        images: _data.data.images[0],
                        content: _data.data.content,
                    }
                }
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.addActive();
                    }
                });
            },
            async addActive() {
                this.loading = true
                let _data = this.id ? await editActive(this.id, this.ruleForm.title, this.ruleForm.content, this.ruleForm.images)
                    : await addActive(this.ruleForm.title, this.ruleForm.content, this.ruleForm.images)
                this.loading = false
                if (_data.status === 200) {
                    this.$message.success(_data.msg)
                    this.$router.go(-1)
                }
            },
            beforeAvatarUpload(file) {
                this.QiniuData.fname = file.name;
                this.QiniuData.key = `${new Date().getTime()}${file.name}`
                this.uping = this.$loading({
                    lock: true,
                    text: "上传中，请稍后",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.2)",
                });
            },
            uploadSuccess(response) {
                this.uping.close();
                this.ruleForm.images = `${filePath}/${response.key}`
            },
            //  上传失败
            uploadError() {
                this.uping.close();
                this.$message({
                    message: "上传出错，请重试！",
                    type: "error",
                    center: true,
                });
            },
        },
        filters: {},
        watch: {},
    }
</script>

<style scoped lang="scss">
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 154px;
        height: 116px;
        line-height: 116px;
        text-align: center;
        border: 1px dashed #d9d9d9;
    }

    .avatar {
        width: 154px;
        height: 116px;
    }

    .warpper {
        background-color: #ffffff;
        border-radius: 10px;
        padding: 20px;
    }
</style>